import $ from "jquery";
import "jquery-validation";
import "jquery-validation-unobtrusive";
import "bootstrap";
import "slick-carousel";
import "inputmask/dist/jquery.inputmask.js";

import "front-end/extensions/jquery.extensions";
import "front-end/extensions/jquery-validation.extentions";
import "front-end/extensions/string.extensions";

import { frontend } from "front-end/app";

window.$ = window.jQuery = $;

$(() => frontend.init());
